import {
  ADOBE_SC_ADD_EVENT_KEY,
  ADOBE_SC_OPEN_EVENT_KEY,
  ADOBE_ADD_SAVED_ITEM_TO_BAG_EVENT_KEY
} from "../../../../../../services/analytics/constants";

export default ({ price }) => [
  ADOBE_SC_ADD_EVENT_KEY,
  ADOBE_SC_OPEN_EVENT_KEY,
  { [ADOBE_ADD_SAVED_ITEM_TO_BAG_EVENT_KEY]: price }
];
